import { ProductName } from "src/components/product-details/buyBox/ProductName"
import { ProductPrice } from "src/components/product-details/buyBox/ProductPrice"
import { ProductRating } from "src/components/product-details/buyBox/ProductRating"
import { ProductSeriesName } from "src/components/product-details/buyBox/ProductSeriesName"

export const ProductTop = () => {
  return (
    <div className="flex w-full flex-col gap-2">
      <ProductSeriesName />

      <div className="flex items-start justify-between gap-4">
        <div className="flex flex-1 flex-col gap-2">
          <ProductName />
          <ProductRating />
        </div>

        <ProductPrice />
      </div>
    </div>
  )
}
